import { render, staticRenderFns } from "./FormProductionTypeLocale.vue?vue&type=template&id=523de625&scoped=true&"
import script from "./FormProductionTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormProductionTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523de625",
  null
  
)

export default component.exports